import { createExternalCalendarEvent as _createExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  CreateCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const createExternalCalendarEvent = async (
  payload: CreateCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _createExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-create-event' },
    });
    throw error;
  }
};
